import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiConnectService} from '../../../services/api-connect.service';

@Injectable()
export class StdManagementService {

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService) { }

  // Standards management
  searchManagementUser(searchField, searchOperation, searchValue, groupId, positionId) {
    const parameters = {
      searchField: searchField,
      searchOperation: searchOperation,
      searchValue: searchValue,
      groupId: groupId,
      positionId: positionId
    };
    let params = new HttpParams();
    if (searchField !== '') {
      params = params.set('searchField', parameters.searchField);
    }
    if (searchOperation !== '') {
      params = params.set('searchOperation', parameters.searchOperation);
    }
    if (searchValue !== '') {
      params = params.set('searchValue', parameters.searchValue);
    }
    if (groupId !== '') {
      params = params.set('groupId', parameters.groupId);
    }
    if (positionId !== '') {
      params = params.set('positionId', parameters.positionId);
    }
    return this.http.get(this.apiURL.searchManagementUser, {
      params: params,
      observe: 'response'
    });
  }

  searchManagementGroup(searchField, searchOperation, searchValue, positionId, userId) {
    const parameters = {
      searchField: searchField,
      searchOperation: searchOperation,
      searchValue: searchValue,
      positionId: positionId,
      userId: userId
    };
    let params = new HttpParams();
    if (searchField !== '') {
      params = params.set('searchField', parameters.searchField);
    }
    if (searchOperation !== '') {
      params = params.set('searchOperation', parameters.searchOperation);
    }
    if (searchValue !== '') {
      params = params.set('searchValue', parameters.searchValue);
    }
    if (positionId !== '') {
      params = params.set('positionId', parameters.positionId);
    }
    if (userId !== '') {
      params = params.set('userId', parameters.userId);
    }
    return this.http.get(this.apiURL.searchManagementGroup, {
      params: params,
      observe: 'response'
    });
  }

  searchManagementPositions(searchField, searchOperation, searchValue, groupId, userId) {
    const parameters = {
      searchField: searchField,
      searchOperation: searchOperation,
      searchValue: searchValue,
      groupId: groupId,
      userId: userId
    };
    let params = new HttpParams();
    if (searchField !== '') {
      params = params.set('searchField', parameters.searchField);
    }
    if (searchOperation !== '') {
      params = params.set('searchOperation', parameters.searchOperation);
    }
    if (searchValue !== '') {
      params = params.set('searchValue', parameters.searchValue);
    }
    if (groupId !== '') {
      params = params.set('groupId', parameters.groupId);
    }
    if (userId !== '') {
      params = params.set('userId', parameters.userId);
    }
    return this.http.get(this.apiURL.searchManagementPositions, {
      params: params,
      observe: 'response'
    });
  }

  searchStandardsWithUser(groupId, positionId, userId) {
    const parameters = {
      groupId: groupId,
      positionId: positionId,
      userId: userId
    };
    let params = new HttpParams();
    if (groupId !== '') {
      params = params.set('groupId', parameters.groupId);
    }
    if (positionId !== '') {
      params = params.set('positionId', parameters.positionId);
    }
    if (userId !== '') {
      params = params.set('userId', parameters.userId);
    }
    return this.http.get(this.apiURL.searchManagementStandardsWithUser, {
      params: params,
      observe: 'response'
    });
  }

  searchPersonalStandards(groupId, positionId, userId) {
    const parameters = {
      groupId: groupId,
      positionId: positionId,
      userId: userId
    };
    let params = new HttpParams();
    if (groupId !== '') {
      params = params.set('groupId', parameters.groupId);
    }
    if (positionId !== '') {
      params = params.set('positionId', parameters.positionId);
    }
    if (userId !== '') {
      params = params.set('userId', parameters.userId);
    }
    return this.http.get(this.apiURL.searchPersonalStandards, {
      params: params,
      observe: 'response'
    });
  }

  searchStandardsWithName(groupId, positionId, number, name) {
    const parameters = {
      groupId: groupId,
      positionId: positionId,
      number: number,
      name: name
    };

    let params = new HttpParams();

    if (groupId !== '') {
      params = params.set('groupId', parameters.groupId);
    }
    if (positionId !== '') {
      params = params.set('positionId', parameters.positionId);
    }
    if (number !== '') {
      params = params.set('number', parameters.number);
    }
    if (name !== '') {
      params = params.set('name', parameters.name);
    }

    return this.http.get(this.apiURL.searchStandardsWithName,  {
      params: params,
      observe: 'response'
    });
  }

  searchStandardsWithoutUserOnPosition(groupId, positionId, userId) {
    const parameters = {
      groupId: groupId,
      positionId: positionId,
      userId: userId
    };

    let params = new HttpParams();

    if (groupId !== '') {
      params = params.set('groupId', parameters.groupId);
    }
    if (positionId !== '') {
      params = params.set('positionId', parameters.positionId);
    }
    if (userId !== '') {
      params = params.set('userId', parameters.userId);
    }

    return this.http.get(this.apiURL.searchStandardsWithoutUserOnPosition,  {
      params: params,
      observe: 'response'
    });
  }

  removeUsersFromStandards(standards, groupId, positionId, userId) {
    const body = {
      standards: standards,
      groupId: groupId,
      positionId: positionId,
      userId: userId
    };

    if (groupId.length < 1) {
      delete body.groupId;
    }
    if (positionId.length < 1) {
      delete body.positionId;
    }
    if (userId.length < 1) {
      delete body.userId;
    }

    return this.http.post(this.apiURL.removeUsersFromStd, body, {
      observe: 'response'
    });
  }

  assignStandards(standards, groupId, positionId, userId) {
    const body = {
      standards: standards,
      groupId: groupId,
      positionId: positionId,
      userId: userId
    };

    if (groupId.length < 1) {
      delete body.groupId;
    }
    if (positionId.length < 1) {
      delete body.positionId;
    }
    if (userId.length < 1) {
      delete body.userId;
    }

    return this.http.post(this.apiURL.assignStandards, body, {
      observe: 'response'
    });
  }


}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/std-management.service.ts